import { ReactNode } from 'react';

import {
    Align,
    Box,
    BoxContent,
    DirectionEnum,
    FlexBox,
    GapSize,
    Icon,
    IconName,
    IconSize,
    Text,
    TextLevels,
    TrilogyColor,
    TypographyBold,
} from '@bytel/trilogy-react';

import { BigIcon, BigIconVariant } from '@components/big';

export interface BigLameProps {
    title: string | ReactNode;
    elements: ({ key: string } & BigLameContentProps)[];
}

export function BigLame({ title, elements }: Readonly<BigLameProps>) {
    return (
        <Box
            backgroundColor={TrilogyColor.ACCENT_FADE}
            highlighted={TrilogyColor.ACCENT}
            shadowless
            radius='md'
            padding='md'
        >
            <BoxContent>
                <FlexBox
                    align={{ mobile: Align.START, desktop: Align.CENTER }}
                    gap={GapSize.FOUR}
                    direction={{ mobile: DirectionEnum.COLUMN, desktop: DirectionEnum.ROW }}
                >
                    <FlexBox gap={GapSize.FOUR}>
                        <BigIcon variant={BigIconVariant.ACCENT} height={20} />
                        <Text level={TextLevels.ONE} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>
                            {title}
                        </Text>
                    </FlexBox>
                    {elements.length > 0 && (
                        <FlexBox
                            align={{ mobile: Align.START, tablet: Align.CENTER }}
                            gap={{ mobile: GapSize.TWO, tablet: GapSize.FOUR }}
                            direction={{ mobile: DirectionEnum.COLUMN, tablet: DirectionEnum.ROW }}
                        >
                            {elements.map(({ key, ...element }) => (
                                <BigLameContent key={key} {...element} />
                            ))}
                        </FlexBox>
                    )}
                </FlexBox>
            </BoxContent>
        </Box>
    );
}

interface BigLameContentProps {
    iconName?: IconName;
    image?: ReactNode;
    text: string | ReactNode;
}

function BigLameContent({ iconName, image, text }: Readonly<BigLameContentProps>) {
    return (
        <FlexBox align={Align.CENTER} gap={GapSize.TWO}>
            {iconName && <Icon name={iconName} size={IconSize.SMALL} />}
            {image}
            {text && <Text level={TextLevels.THREE}>{text}</Text>}
        </FlexBox>
    );
}
